export const chatStubData = [
	{
		hasUnreadMessages: false,
		id: 'global',
		title: 'Общий',
		messages: [
			{
				id: 'msg-1',
				sender: 'JewJew',
				text: 'Ну как там у всех успехи?',
				color: { r: 250, g: 190, b: 44 },
			},
			{
				id: 'msg-2',
				sender: 'MaxVolla',
				text: 'Пилится - делается)',
				color: { r: 255, g: 255, b: 255 },
			},
			{
				id: 'msg-3',
				sender: 'Jevico',
				text: 'Мне осталось вообще немного, чутка доделать худ в МТА и я с вами xD',
				color: { r: 210, g: 255, b: 82 },
			},
			{
				id: 'msg-4',
				sender: 'Loodrive',
				text: 'Через неделю открытие, кайф)',
				color: { r: 132, g: 211, b: 255 },
			},
			{
				id: 'msg-5',
				sender: 'iMineev',
				text: 'Влад, хули ты тут делаешь?',
				color: { r: 255, g: 114, b: 70 },
			},
			{
				id: 'msg-6',
				sender: 'iMineev',
				text: 'Быстро в мта!!!',
				color: { r: 255, g: 114, b: 70 },
			},
			{
				id: 'msg-7',
				text: 'Уважаемые игроки, до рестарта сервера осталось 17 минут!',
				color: { r: 255, g: 70, b: 70 },
			},
			{
				id: 'msg-8',
				sender: 'unnamed.ab',
				text: 'А где панель для админов?',
				color: { r: 247, g: 215, b: 132 },
			},
			{
				id: 'msg-9',
				sender: 'Wherry',
				text: 'Нужно полностью переделать весь сервер!!!',
				color: { r: 0, g: 133, b: 255 },
			},
			{
				id: 'msg-10',
				sender: 'iMineev',
				text: 'Ну у нас же сроки...',
				color: { r: 255, g: 114, b: 70 },
			},
		],
	},
	{
		hasUnreadMessages: true,
		id: 'trading',
		title: 'Торговый',
		messages: [
			{
				id: 'msg-11',
				sender: 'JewJew',
				text: 'Куплю дом у вайнвуда за 5кк',
				color: { r: 250, g: 190, b: 44 },
			},
			{
				id: 'msg-12',
				text: 'Игрок JewJew купил дом у вайнвуда за 5кк',
				color: { r: 25, g: 255, b: 25 },
			},
			{
				id: 'msg-13',
				sender: 'iMineev',
				text: 'Продам дом в ЛС за 10кк',
				color: { r: 255, g: 114, b: 70 },
			},
			{
				id: 'msg-14',
				text: 'Игрок iMineev продал дом в ЛС за 10кк',
				color: { r: 25, g: 255, b: 25 },
			},
		],
	},
	{
		hasUnreadMessages: false,
		id: 'clan',
		title: 'Клан',
		messages: [
			{
				id: 'msg-15',
				sender: 'Wherry',
				text: 'Кто хочет вступить в клан?',
				color: { r: 0, g: 133, b: 255 },
			},
			{
				id: 'msg-16',
				sender: 'iMineev',
				text: 'Я хочу!',
				color: { r: 255, g: 114, b: 70 },
			},
			{
				id: 'msg-7',
				sender: 'Wherry',
				text: 'Ну тогда вступай в клан!',
				color: { r: 0, g: 133, b: 255 },
			},
			{
				id: 'msg-18',
				sender: 'JewJew',
				text: 'Можно и я?',
				color: { r: 250, g: 190, b: 44 },
			},
			{
				id: 'msg-19',
				sender: 'Wherry',
				text: 'Нет',
				color: { r: 0, g: 133, b: 255 },
			},
			{
				id: 'msg-20',
				sender: 'JewJew',
				text: 'Почему?',
				color: { r: 250, g: 190, b: 44 },
			},
			{
				id: 'msg-21',
				sender: 'Wherry',
				text: 'Потому что ты плохой',
				color: { r: 0, g: 133, b: 255 },
			},
			{
				id: 'msg-22',
				sender: 'JewJew',
				text: 'А я не плохой',
				color: { r: 250, g: 190, b: 44 },
			},
			{
				id: 'msg-23',
				sender: 'Wherry',
				text: 'Ну тогда вступай в клан!',
				color: { r: 0, g: 133, b: 255 },
			},
			{
				id: 'msg-24',
				sender: 'JewJew',
				text: 'Спасибо!',
				color: { r: 250, g: 190, b: 44 },
			},
			{
				id: 'msg-25',
				sender: 'Wherry',
				text: 'Не за что',
				color: { r: 0, g: 133, b: 255 },
			},
			{
				id: 'msg-26',
				sender: 'MaxVolla',
				text: 'А кто вообще в клане?',
				color: { r: 255, g: 255, b: 255 },
			},
			{
				id: 'msg-27',
				sender: 'Wherry',
				text: 'Я, iMineev и JewJew',
				color: { r: 0, g: 133, b: 255 },
			},
			{
				id: 'msg-28',
				sender: 'MaxVolla',
				text: 'А можно и мне?',
				color: { r: 255, g: 255, b: 255 },
			},
			{
				id: 'msg-29',
				sender: 'Wherry',
				text: 'Нет',
				color: { r: 0, g: 133, b: 255 },
			},
			{
				id: 'msg-30',
				sender: 'MaxVolla',
				text: 'Почему?',
				color: { r: 255, g: 255, b: 255 },
			},
			{
				id: 'msg-31',
				sender: 'Wherry',
				text: 'Потому что ты плохой',
				color: { r: 0, g: 133, b: 255 },
			},
			{
				id: 'msg-32',
				sender: 'MaxVolla',
				text: 'А я не плохой',
				color: { r: 255, g: 255, b: 255 },
			},
			{
				id: 'msg-33',
				sender: 'Wherry',
				text: 'Ну тогда вступай в клан!',
				color: { r: 0, g: 133, b: 255 },
			},
			{
				id: 'msg-34',
				sender: 'MaxVolla',
				text: 'Спасибо!',
				color: { r: 255, g: 255, b: 255 },
			},
			{
				id: 'msg-35',
				sender: 'Wherry',
				text: 'Не за что',
				color: { r: 0, g: 133, b: 255 },
			},
			{
				text: 'Клановый чат отключен администратором',
				color: { r: 255, g: 70, b: 70 },
			},
		],
	},
];
